// Path-based locale handling: /de/apps/equilab, /nl/rankings, etc.
// English lives at the root (no prefix); the other 22 languages get a path prefix.
import { SUPPORTED_LANGUAGES } from "./languages";

export const LANG_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);
const NON_EN = new Set(LANG_CODES.filter((c) => c !== "en"));

// "/de/apps/x" -> "de", "/apps/x" -> null
export const langFromPath = (pathname) => {
  const seg = (pathname || "/").split("/")[1];
  return NON_EN.has(seg) ? seg : null;
};

// Strip the lang path prefix and any legacy ?lang= param → clean canonical EN URL.
export const cleanUrl = (href) => {
  const u = new URL(href);
  const lp = langFromPath(u.pathname);
  if (lp) u.pathname = u.pathname.slice(lp.length + 1) || "/";
  u.searchParams.delete("lang");
  u.hash = "";
  return u.toString().replace(/\?$/, "");
};

// Clean EN absolute URL + lang → localized path URL ("/" -> "/de", "/apps/x" -> "/de/apps/x")
export const localizedUrl = (cleanHref, lang) => {
  if (!lang || lang === "en") return cleanHref;
  const u = new URL(cleanHref);
  u.pathname = `/${lang}${u.pathname === "/" ? "" : u.pathname}`;
  return u.toString();
};

// Language of the CURRENT URL (path prefix wins, legacy ?lang= second). Deterministic
// for prerenderers — never reads localStorage.
export const urlLang = () => {
  if (typeof window === "undefined") return "en";
  const fromPath = langFromPath(window.location.pathname);
  if (fromPath) return fromPath;
  const q = new URL(window.location.href).searchParams.get("lang");
  return q && NON_EN.has(q) ? q : "en";
};

// Computed once at module load — used as the router basename so every internal
// <Link> automatically keeps the /{lang}/ prefix.
export const PATH_LANG = typeof window !== "undefined" ? langFromPath(window.location.pathname) : null;
export const ROUTER_BASENAME = PATH_LANG ? `/${PATH_LANG}` : "/";

// Legacy ?lang=xx URLs (old sitemap format) → JS redirect to the path form so
// Google consolidates the old query URLs onto the new path URLs.
if (typeof window !== "undefined" && !PATH_LANG) {
  const q = new URL(window.location.href).searchParams.get("lang");
  if (q && NON_EN.has(q)) {
    window.location.replace(localizedUrl(cleanUrl(window.location.href), q));
  }
}
